module.exports = __webpack_public_path__ + "img/storage_y.c9211bf0.svg";